module.exports = __webpack_public_path__ + "media/images/icon-history-active-93e3f229f15426bb4b937b4c5e3cf897.svg";